import React from 'react';
import { motion } from 'framer-motion';
import { INCIDENT_TYPE_CONFIG } from '../constants';
import type { IncidentType, IncidentStatus } from '../types';

interface StatusBadgeProps {
    type: IncidentType;
    status: IncidentStatus;
    showPulse?: boolean;
    size?: 'sm' | 'md' | 'lg';
    showStatusLabel?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
    type,
    status,
    showPulse = false,
    size = 'md',
    showStatusLabel = false
}) => {
    const typeConfig = INCIDENT_TYPE_CONFIG[type];
    
    const sizeClasses = {
        sm: 'px-2 py-0.5 text-[10px] gap-1',
        md: 'px-2.5 py-1 text-[11px] gap-1.5',
        lg: 'px-3 py-1.5 text-[12px] gap-2'
    };

    const dotSizes = {
        sm: 'w-1 h-1',
        md: 'w-1.5 h-1.5',
        lg: 'w-2 h-2'
    };

    const badgeText = showStatusLabel && status !== 'resolved' 
        ? (status === 'active' ? 'Активен' : 'Расследуется')
        : typeConfig.label;

    return (
        <motion.span
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className={`
                inline-flex items-center rounded-full font-medium
                ${sizeClasses[size]}
            `}
            style={{
                backgroundColor: typeConfig.bgColor,
                color: typeConfig.textColor,
                border: `1px solid ${typeConfig.borderColor}`
            }}
        >
            <span className="relative flex items-center justify-center">
                <span
                    className={`rounded-full ${dotSizes[size]}`}
                    style={{ backgroundColor: typeConfig.color }}
                />
                {showPulse && status === 'active' && (
                    <motion.span
                        className={`absolute rounded-full ${dotSizes[size]}`}
                        style={{ backgroundColor: typeConfig.color }}
                        animate={{
                            scale: [1, 2],
                            opacity: [0.7, 0]
                        }}
                        transition={{
                            duration: 1.5,
                            repeat: Infinity,
                            ease: "easeOut"
                        }}
                    />
                )}
            </span>
            {badgeText}
        </motion.span>
    );
};